import { favoritesSessionStorageKey, pendingSavesSessionStorageKey } from "../constants/sessionStorageConstants";

// Read "pendingSaves" session storage on initial load
const pendingSavesData= sessionStorage.getItem(pendingSavesSessionStorageKey, false);
// Assign value to a list
const pendingSaves = pendingSavesData ? JSON.parse(pendingSavesData) : [];

// Read "favorites" information on initial load
const favoritesData = sessionStorage.getItem(favoritesSessionStorageKey, false);
const favorites = favoritesData ? JSON.parse(favoritesData) : [];

export default {
  name: '',
  email: '',
  phone: '',
  zip: '',
  livesOutside: false,
  pendingSaves,
  favorites,
  hasUserOptedIntoRecommendationEmail: true,
  realtorQuestion : ''
}